import React, {useState} from 'react';
import SubHeader from '../general/SubHeader';
import '../css/components/SchoolLogin.css';
import { useNavigate } from 'react-router-dom';

const SchoolLogin = ({setResponse, setLoading}) => {


                const [formData, setFormData] = useState({
                  id: '',
                  pass: '',
                })

                        const navigate = useNavigate();
    
                      // Handle form data change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


    const handleLogin = async (e) => {
    e.preventDefault();
    setResponse('');

    if (formData.id === 'KC@1234' && formData.pass === '1234') {
      // If they match, navigate to the dashboard
      localStorage.setItem('isWebAdmin', 'true');
      setResponse({ message: 'Web Panel Login Success!', status: 'success' });
      setTimeout(() => {setResponse('');         navigate('/web-dashboard');}, 2000);
    } else {
        
      setResponse({ message: 'Incorrect Credentials', status: 'error' });
      setTimeout(() => setResponse(''), 2000);
    }
  }

  return (
    <>
      {/* <SubHeader message="School Login" /> */}

<section className='my-5 px-4'>
    <div className='school-login col-lg-5 col-md-6 col-sm-7 mx-auto'>

<div className='d-flex text-center login-text'><p className='text-center w-75 align-content-center text-blue'>School</p>
<p className='res-blue text-light w-100 px-4 py-3'>Login Now</p>
</div>
{/* <hr className='slider-hr mx-auto' /> */}

<form class="row g-3 mt-4 px-4 pb-5" onSubmit={handleLogin}>
  <div class="col-12">
    <label className='login-label'>School Id</label>
    <input type="text" class="login-control" id="inputMobile4" name='id' onChange={handleChange} value={formData.id} />
  </div>
  <div class="col-12">
    <label className='login-label'>Password</label>
    <input type="password" class="login-control" id="inputPassword4" name='pass' onChange={handleChange} value={formData.pass} />
  </div>
  <div class="col-12 mt-4">
    <button type="submit" class="login-btn">Sign in</button>
  </div>
</form>


    </div>
</section>

      
    </>
  )
}

export default SchoolLogin
